(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('templates/orgForm.tpl.html', [
'<form class="form-horizontal" name="orgForm">',
'',
'  <div ng-if="!model">no model</div>',
'',
'  <div class="row org-form">',
'',
'    <div class="col-md-12">',
'',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.name}">',
'        <label class="col-sm-4" for="name" translate>org.name</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.name" class="form-control" id="name"',
'            placeholder="" ng-required="required.name">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.shortName}">',
'        <label class="col-sm-4" for="shortName" translate>org.shortName</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.shortName" class="form-control" id="shortName"',
'            placeholder="" ng-required="required.shortName" shortname shortname-lower>',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.type}">',
'        <label class="col-sm-4" for="type" translate>org.type</label>',
'        <div class="col-sm-8">',
'          <select ng-model="model.orgType" class="form-control" id="type"',
'            placeholder="" ng-required="required.type">',
'            <option ng-repeat="o in orgTypeValues" value="{{o}}">{{::o}}</option>',
'          </select>',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.address}">',
'        <label class="col-sm-4" for="address" translate>org.address</label>',
'        <div class="col-sm-8">',
'          <textarea ng-model="model.address" class="form-control" id="address"',
'                    placeholder="" ng-required="required.address"></textarea>',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.description}">',
'        <label class="col-sm-4" for="address">',
'          <span translate>org.description</span><br>',
'          <small class="text-muted" style="font-weight: normal" translate>org.maxdesc</small>',
'        </label>',
'        <div class="col-sm-8">',
'          <textarea ng-model="model.description" class="form-control" id="description" maxlength="255"',
'                    placeholder="{{ \'org.maxdesc\' | translate }}" ng-required="required.description"></textarea>',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.note}">',
'        <label class="col-sm-4" for="note" translate>org.note</label>',
'        <div class="col-sm-8">',
'          <textarea ng-model="model.note" class="form-control" id="note"',
'            placeholder="" ng-required="required.note"></textarea>',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.url}">',
'        <label class="col-sm-4" for="url" translate>org.url</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.url" class="form-control" id="url" type="url"',
'            placeholder="" ng-required="required.url">',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-class="{required: required.mail}">',
'        <label class="col-sm-4" for="mail" translate>org.mail</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.mail" class="form-control" id="mail" type="mail"',
'                 placeholder="" ng-required="required.mail">',
'        </div>',
'      </div>',
'',
'      <imageinput model="model" attribute="\'logo\'"></imageinput>',
'',
'    </div>',
'',
'  </div>',
'',
'</form>',
'',''].join("\n"));
  }]);
})();